import { centerCrop as ricCenterCrop, makeAspectCrop } from "react-image-crop";

const ASPECT_RATIO_HERO = 1;
const ASPECT_RATIO_BANNER = 3;

const centerCrop = (width: number, height: number, banner = false) =>
  ricCenterCrop(
    makeAspectCrop(
      {
        unit: "%",
        width: 90,
      },
      banner ? ASPECT_RATIO_BANNER : ASPECT_RATIO_HERO,
      width,
      height
    ),
    width,
    height
  );

export { ASPECT_RATIO_HERO, ASPECT_RATIO_BANNER, centerCrop };
